import { z } from 'zod';
import { findingGroups } from '@/features/agentic-insights/components/data/types';

/**
 * The whole surface's state lives in the URL, so a link reproduces exactly what someone was looking
 * at — which run, filtered to which objective, with which finding open.
 *
 * No reading to address, unlike the pass this was copied from: a feed has one shape, and the
 * rail-and-pane mode has no place in it.
 *
 * Every field is `.catch(undefined)` rather than plain `.optional()`: these arrive from a
 * hand-editable address bar, and a value that does not resolve should fall back to the default rather
 * than throw a route error at someone who mistyped a link.
 */
export const loopIntelligenceSearchSchema = z.object({
  runId: z.string().min(1).optional().catch(undefined),
  objective: z.string().min(1).optional().catch(undefined),
  group: z.enum(findingGroups).optional().catch(undefined),
  finding: z.string().min(1).optional().catch(undefined),
});

export type LoopIntelligenceSearch = z.infer<typeof loopIntelligenceSearchSchema>;
